export default "__VITE_ASSET__VXUUQKyG__"